module.exports = __webpack_public_path__ + "img/icon-ao.b51d2f7c.png";